import React from 'react';
import { GenericDescriptionList } from 'web-ui-components/lib/data/lists';
import { getShareHolderPercentage } from '../personDetailsSection/utils/personaDetailsUtils';

export const renderForSecondaryComponent = (
  authorizedSignitory,
  officerInfo,
  percentagePerOwnCompany,
  underPercentage,
  companyDirector,
  isSoleTrader
) => (
  <GenericDescriptionList
    items={getItems(
      authorizedSignitory,
      officerInfo,
      percentagePerOwnCompany,
      underPercentage,
      companyDirector,
      isSoleTrader
    )}
  />
);

const getItems = (
  authorizedSignitory,
  officerInfo,
  percentagePerOwnCompany,
  underPercentage,
  companyDirector,
  isSoleTrader
) => {
  const list = [{ key: authorizedSignitory, value: officerInfo.authorisedSignatory }];

  !isSoleTrader &&
    list.push(renderPercentage(percentagePerOwnCompany, officerInfo, underPercentage));
  !isSoleTrader && list.push(renderDirector(isSoleTrader, companyDirector, officerInfo));
  return list;
};

export const renderDirector = (companyDirector, officerInfo) => {
  return { key: companyDirector, value: officerInfo.companyDirector };
};

export const renderPercentage = (percentagePerOwnCompany, officerInfo, underPercentage) => {
  return {
    key: percentagePerOwnCompany,
    value: getShareHolderPercentage(
      officerInfo.ownCompany,
      officerInfo.percentPersonOwnCompany,
      underPercentage
    )
  };
};
